import {Container} from "./styled";
import {IconButton} from "components";
import {useContextTheme} from "context";
import {useTheme} from "styled-components";
import {useAppDispatch, useAppSelector} from "hooks";
import {LogOut, Menu, Moon, Sun} from "react-feather";
import {logOut, toggleFullScreenLoader} from "global/slices";
import {Brand, Options, Row, Typography} from "components/@system";

interface TopBarProps {}

const greetings = (): string => {
  let greeting = "Buenas noches";
  const currentHour = new Date().getHours();

  if (currentHour >= 5 && currentHour < 12) {
    greeting = "Buen día";
  } else if (currentHour >= 12 && currentHour < 19) {
    greeting = "Buenas tardes";
  }
  return greeting;
};

export const TopBar: React.FC<TopBarProps> = () => {
  const dispatch = useAppDispatch();
  const {user} = useAppSelector("auth");
  const {hover, blackWhite, heart} = useTheme();
  const {toggle: toggleTheme, isDark} = useContextTheme();
  const ThemeIcon = isDark ? Sun : Moon;

  return (
    <Container>
      <Row>
        <Brand />
        <Typography fontFamily="Rubik-Medium" fontSize={20}>
          {greetings()}, {user["name"]}
        </Typography>
      </Row>
      <Options
        listStyle={{width: 195, right: 0}}
        options={[
          {
            onClick: toggleTheme,
            label: "Cambiar tema",
            icon: <ThemeIcon color={blackWhite} />,
            style: {borderRadius: 0},
          },
          {
            label: "Cerrar sesión",
            icon: <LogOut color={heart} />,
            typographyProps: {color: heart},
            style: {borderRadius: "0 0 5px 5px"},
            onClick: () => {
              dispatch(toggleFullScreenLoader(true));
              dispatch(logOut());
            },
          },
        ]}
      >
        {({toggle}) => (
          <IconButton
            onClick={toggle}
            style={{backgroundColor: hover}}
            icon={<Menu style={{color: blackWhite}} />}
          />
        )}
      </Options>
    </Container>
  );
};
